import { SystemAlertRecommendationFilters } from "@features/ax/srvc-and-mgmt/systemAlerts/types";
import {
  ActionType,
  EntityType,
  ModuleType,
} from "@shared/api/queries/queryKeyFactory";

export const serviceAndMangement = {
  serviceOrderAssets: {
    list: (
      remoteUtilityId: string,
      page?: number,
      limit?: number,
      searchData?: string,
      assetType?: string,
      area?: string,
      system?: string,
      network?: string,
      facility?: string
    ): [ModuleType, EntityType, ActionType, ...any[]] => [
      "ax",
      "serviceOrderAssets",
      "list",
      remoteUtilityId,
      page,
      limit,
      searchData,
      assetType,
      area,
      system,
      network,
      facility,
    ],
  },

  serviceOrderSystems: {
    list: (
      remoteUtilityId: string,
      page?: number,
      limit?: number,
      searchData?: string,
      systemType?: string,
      area?: string,
      facility?: string
    ): [ModuleType, EntityType, ActionType, ...any[]] => [
      "ax",
      "serviceOrderSystems",
      "list",
      remoteUtilityId,
      page,
      limit,
      searchData,
      systemType,
      area,
      facility,
    ],
  },

  serviceOrderFacilities: {
    list: (
      remoteUtilityId: string,
      page?: number,
      limit?: number,
      searchData?: string,
      facilityType?: string,
      area?: string
    ): [ModuleType, EntityType, ActionType, ...any[]] => [
      "ax",
      "serviceOrderFacilities",
      "list",
      remoteUtilityId,
      page,
      limit,
      searchData,
      facilityType,
      area,
    ],
  },

  serviceOrderNetworks: {
    list: (
      remoteUtilityId: string,
      page?: number,
      limit?: number,
      searchData?: string,
      networkType?: string,
      area?: string,
      facility?: string
    ): [ModuleType, EntityType, ActionType, ...any[]] => [
      "ax",
      "serviceOrderNetworks",
      "list",
      remoteUtilityId,
      page,
      limit,
      searchData,
      networkType,
      area,
      facility,
    ],
  },
  systemAlert: {
    dashboardKpis: (
      remoteUtilityId: string
    ): [ModuleType, EntityType, ActionType, string] => [
      "ax",
      "systemAlerts",
      "recommendationsDashboardKpis",
      remoteUtilityId,
    ],
    recommendations: (
      remoteUtilityId: string,
      filters: SystemAlertRecommendationFilters
    ): [
      ModuleType,
      EntityType,
      ActionType,
      string,
      SystemAlertRecommendationFilters
    ] => ["ax", "systemAlerts", "recommendations", remoteUtilityId, filters],
  },
  serviceOrder: {
    list: (
      remoteUtilityId: string,
      page?: number,
      limit?: number,
      searchData?: string,
      status?: string,
      priority?: string,
      sopAssociationType?: string,
      fieldForceName?: string
    ): [ModuleType, EntityType, ActionType, ...any[]] => [
      "ax",
      "serviceOrders",
      "list",
      remoteUtilityId,
      page,
      limit,
      searchData,
      status,
      priority,
      sopAssociationType,
      fieldForceName,
    ],
    summary: (
      remoteUtilityId: string
    ): [ModuleType, EntityType, ActionType, string] => [
      "ax",
      "serviceOrders",
      "summary",
      remoteUtilityId,
    ],
    details: (
      remoteUtilityId: string,
      serviceOrderId: string
    ): [ModuleType, EntityType, ActionType, string, string] => [
      "ax",
      "serviceOrders",
      "details",
      remoteUtilityId,
      serviceOrderId,
    ],
    operationType: (): [ModuleType, EntityType, ActionType] => [
      "ax",
      "serviceOrders",
      "operationType",
    ],
  },
  sopTemplate: {
    list: (
      remoteUtilityId: string,
      page?: number,
      limit?: number,
      searchData?: string,
      sopAssociationType?: string,
      status?: string
    ): [ModuleType, EntityType, ActionType, ...any[]] => [
      "ax",
      "sopTemplate",
      "list",
      remoteUtilityId,
      page,
      limit,
      searchData,
      sopAssociationType,
      status,
    ],
  },
  serviceOrderHistory: {
    list: (
      remoteUtilityId: string,
      page?: number,
      limit?: number,
      searchData?: string,
      status?: string,
      priority?: string,
      orderType?: string,
      assignedTo?: string
    ): [ModuleType, EntityType, ActionType, ...any[]] => [
      "ax",
      "serviceOrderHistory",
      "list",
      remoteUtilityId,
      page,
      limit,
      searchData,
      status,
      priority,
      orderType,
      assignedTo,
    ],
    summary: (
      remoteUtilityId: string
    ): [ModuleType, EntityType, ActionType, string] => [
      "ax",
      "serviceOrderHistory",
      "summary",
      remoteUtilityId,
    ],
  },
  serviceOrderDetails: {
    detail: (id: string): [ModuleType, string, ActionType, ...any[]] => [
      "ax",
      "serviceOrderDetails",
      "details",
      id,
    ],
  },
};
